import { includes } from "lodash"
import { makeOptional, markingRoles, markingTabs } from "../routeHelper"

export const templates = {
  id: "marking",
  config: "/marking",
  build: () => "/marking",
  children: [
    {
      id: "markingOverview",
      config: "/marking/:currentTab?",
      build: (currentTab) => {
        if (markingTabs.indexOf(currentTab) === -1) {
          return "/marking"
        }

        return `/marking/${currentTab}`
      },
      children: [
        {
          id: "markingResultsCandidatesList",
          config: "/marking/:currentTab/:id",
          build: (id) => {
            return `/marking/candidateResults/${id}`
          },
        },
      ],
    },
    {
      id: "markingSchedulesResultsExport",
      config: "/marking/candidateResults/items/export",
      build: () => "/marking/candidateResults/items/export",
    },
    {
      id: "markingCandidatesResultsExport",
      config: "/marking/candidateResults/items/:id/export",
      build: (id) => `/marking/candidateResults/items/${id}/export`,
    },
    {
      id: "markingCandidateResultReport",
      config: "/marking/candidateResults/:resultId/:userId/:optional?/report",
      build: (resultId, userId, optional) =>
        `/marking/candidateResults/${resultId}/${userId}${makeOptional(optional)}/report`,
    },
    {
      id: "markingCandidateResultEvaluation",
      config:
        "/marking/candidateResults/:scheduleId/:attemptNumber/evaluate/:examResultId/:candidateId/:questionId",
      build: ({ scheduleId, attemptNumber, examResultId, candidateId, questionId }) =>
        `/marking/candidateResults/${scheduleId}/${attemptNumber}/evaluate/${examResultId}/${candidateId}/${questionId}`,
    },
    {
      id: "assessmentRescoring",
      config: "/marking/reScoring/:scheduleId/:tab",
      build: (scheduleId, tab) => `/marking/reScoring/${scheduleId}/${tab}`,
    },
    {
      id: "markingItemExport",
      config: "/marking/item/:role/:id/export",
      build: ({ scheduleId, markingRole }) => {
        if (!includes(markingRoles, markingRole)) {
          throw new Error(`marking role: ${markingRole} isn't correct`)
        }

        return `marking/item/${markingRole}/${scheduleId}/export`
      },
    },
    {
      id: "markingRemarkingSchedule",
      config: "/marking/remarking/schedules/:scheduleId/candidates",
      build: (scheduleId) => `/marking/remarking/schedules/${scheduleId}/candidates`,
    },
    {
      id: "remarkingCandidateResultEvaluation",
      config:
        "/marking/remarking/schedules/:scheduleId/candidates/:candidateId/evaluate/:examResultId/:questionId",
      build: ({ scheduleId, candidateId, examResultId, questionId }) =>
        `/marking/remarking/schedules/${scheduleId}/candidates/${candidateId}/evaluate/${examResultId}/${questionId}`,
    },
    {
      id: "markingItem",
      config: "/marking/item/:role/:id/:currentTab?",
      build: ({ scheduleId, markingRole, tab }) => {
        if (!includes(markingRoles, markingRole)) {
          throw new Error(`marking role: ${markingRole} isn't correct`)
        }

        return `/marking/item/${markingRole}/${scheduleId}${makeOptional(tab)}`
      },
    },
    {
      id: "markingEvaluation",
      config: "/marking/item/:role/:currentTab/:scheduleId/evaluate/:examResultId/:questionId",
      build: ({ scheduleId, markingRole, examResultId, questionId, currentTab }) => {
        if (!includes(markingRoles, markingRole)) {
          throw new Error(`marking role: ${markingRole} isn't correct`)
        }

        if (["submissions", "progress"].indexOf(currentTab) === -1) {
          currentTab = "submissions"
        }

        return `/marking/item/${markingRole}/${currentTab}/${scheduleId}/evaluate/${examResultId}/${questionId}`
      },
    },
    {
      id: "markingAssessMultiple",
      config: "/marking/moderation/assessMultiple/:id",
      build: (id) => `/marking/moderation/assessMultiple/${id}`,
    },
    {
      id: "markingResults",
      config: "/marking/item/:role/:id/:currentTab/:submissionId/:tabId?",
      build: (id, role, submissionId, currentTab, tabId) => {
        if (!includes(markingRoles, role)) {
          throw new Error(`marking role: ${role} isn't correct`)
        }

        if (["submissions", "progress"].indexOf(currentTab) === -1) {
          currentTab = "submissions"
        }

        return `/marking/item/${role}/${id}/${currentTab}/${submissionId}${makeOptional(tabId)}`
      },
    },
    {
      id: "markingCandidateReport",
      config:
        "/marking/remarking/schedule/:scheduleId/candidates/:candidateId/results/:resultId/:tab?",
      build: (scheduleId, candidateId, resultId, tab = "overview") => {
        return `/marking/remarking/schedule/${scheduleId}/candidates/${candidateId}/results/${resultId}${makeOptional(
          tab,
        )}`
      },
    },
    {
      id: "markingManageAssessors",
      config: "/marking/coordinator/:id/:currentTab",
      build: (id, currentTab = "overview") =>
        `/marking/coordinator/${id}/${currentTab}`,
      children: [
        {
          id: "markingManageAssessorsOverview",
          config: "/marking/coordinator/:id/overview",
          build: (id) => `/marking/coordinator/${id}/overview`
        },
        {
          id: "markingManageAssessorsSettings",
          config: "/marking/coordinator/:id/settings",
          build: (id) => `/marking/coordinator/${id}/settings`
        },
        {
          id: "markingManageAssessorsAssessors",
          config: "/marking/coordinator/:id/assessors",
          build: (id) => `/marking/coordinator/${id}/assessors`
        },
        {
          id: "markingManageAssessorsAllocation",
          config: "/marking/coordinator/:id/allocation",
          build: (id) => `/marking/coordinator/${id}/allocation`
        }
      ]
    },
  ],
}
